export const ROUTE_ACCESS_MAP_DIRECT = {
    // Dashboard & Admin
    '/dashboard': 'dashboard',
    '/admin-dashboard': 'admin_dashboard',

    // User Management
    '/settings/user-manage': 'user_entry',
    '/settings/user-role-manage': 'user_role_manage',
    '/settings/module-access': 'module_access_settings',

    // Company & Branch
    '/settings/institution-profile': 'company_profile',
    '/settings/branch-manage': 'branch_entry',
    '/settings/branch-manage/addNewBranch': 'branch_entry',

    // Warehouse & Inventory
    '/settings/warehouses': 'warehouse_entry',
    '/settings/warehouses/addNewWarehouse': 'warehouse_entry',
    '/settings/tags': 'tag_manage',
    '/settings/subscription-info': 'subscription_info',

    // HR & Payroll
    '/hrpayroll/employees': 'employee_entry',
    '/hrpayroll/onboarding': 'onboarding',
    '/hrpayroll/departments': 'department_entry',
    '/hrpayroll/departments/addNewDepartment': 'department_entry',
    '/hrpayroll/designations': 'designation_entry',
    '/hrpayroll/designations/addNewDesignation': 'designation_entry',
    '/hrpayroll/attendance': 'attendance_entry',
    '/hrpayroll/attendance-overview': 'attendance_overview',
    '/hrpayroll/salary-payments': 'salary_payment',
    '/hrpayroll/salary-payments/add': 'salary_payment',
    '/hrpayroll/salary-payments/edit/:id': 'salary_payment',
    '/hrpayroll/clients-entry': 'clients_entry',
    '/hrpayroll/hrlocation': 'hrlocation',
    // No access-key gate here on purpose: this route is now open to any
    // employee (not just Sales Agent), gated by whether they have a route
    // assigned today rather than a stored permission grant -- the page
    // itself (WorkRoutes/index.jsx) already fully self-gates its content
    // (empty tabs for anyone who's neither an employee nor an admin), so
    // this ProtectedRoute-level check was redundant on top of that, and
    // tying it to a stored DB grant is exactly what caused /no-access for
    // employees without the Sales Agent role.
    // '/hrpayroll/work-routes': 'work_routes',
    '/hrpayroll/hr-settings-view': 'hr_settings_view',

    // Inventory Management
    '/inventory/item-adjustment': 'item_adjustment_entry',
    '/inventory/adjustment-record': 'adjustment_record',
    '/inventory/item-group-entry': 'group_entry',
    '/inventory/item-group-entry/addNewGroup': 'group_entry',
    '/inventory/category': 'item_category',
    '/inventory/category/addNewCategory': 'item_category',
    '/inventory/product': 'item_entry',
    '/inventory/product/addNewItem': 'item_entry',
    '/inventory/manufacturers': 'item_entry',
    '/inventory/item-ledger': 'item_ledger',
    '/inventory/item-stock-report': 'item_stock_report',
    '/reports/item-stock-report': 'item_stock_report',
    '/inventory/unit-manage': 'item_unit',
    '/inventory/unit-manage/addNewUnit': 'item_unit',
    '/inventory/models-manage': 'model_manage',
    '/inventory/models-manage/addNewModel': 'model_manage',
    '/inventory/origins-manage': 'origin_manage',
    '/inventory/origins-manage/addNewOrigin': 'origin_manage',
    '/inventory/racks-manage': 'rack_manage',
    '/inventory/racks-manage/addNewRack': 'rack_manage',
    '/inventory/transfer-entry': 'transfer_entry',
    '/inventory/transfer-pending-record': 'transfer_pending_record',
    '/inventory/transfer-receive-record': 'transfer_receive_record',
    '/inventory/transfer-record': 'transfer_record',
    '/accounts/debitor-pharma-receipts': 'debitor_pharma_receipts',
    '/inventory/heirrachy-flow': 'tatmeen_entry',
    

    // Manufacturing
    '/manufacturing': 'production_entry',
    '/manufacturing/:id': 'production_voucher',
    '/reports/manufacturing-record': 'production_record',

    // Orders
    '/order/purchase': 'purchase_order_entry',
    '/order/purchase-order-update/:id': 'purchase_order_voucher',
    '/reports/purchase-order-record': 'purchase_order_record',
    '/order/sales': 'sales_order_entry',
    '/reports/sales-order-record': 'sales_order_record',
    '/sales/order-to-sales/:id': 'sales_order_voucher',

    // POS
    '/pos/pos-entry': 'pos_entry',
    '/sales/quick-pos/:id': 'pos_entry',

    // Purchase
    '/purchase': 'purchase_entry',
    '/purchase/quick-purchase-voucher/:id': 'purchase_voucher',
    '/reports/purchase-record': 'purchase_record',
    '/purchase-return': 'purchase_return',
    '/purchase/quick-purchase-return-voucher/:id': 'purchase_return_voucher',
    '/reports/purchase-return-record': 'purchase_return_record',
    '/purchase/addNewSupplier': 'supplier_entry',

    // Tatmeen (standalone module)
    '/tatmeen': 'tatmeen_entry',

    // Quotation
    '/quotation/quotation': 'quotation_entry',
    '/quotation/quick-quotation-voucher/:id': 'quotation_entry',
    '/quotation/quotation-record': 'quotation_record',

    // Sales
    // '/sales-dashboard': 'new_sales',
    '/invoice': 'new_sales',
    '/sales/quick-sales-voucher/:id': 'sales_voucher',
    '/sales-record': 'sales_record',
    '/sales-return': 'sales_return',
    '/sales/quick-sales-return-voucher/:id': 'sales_return_voucher',
    '/sales-return-record': 'sales_return_record',
    '/customers': 'customer_entry',
    '/customers/addNewCustomer': 'customer_entry',
    '/product-replace': 'product_replace',
    '/sales/quick-replace-voucher/:id': 'product_replace',
    '/product-replace-record': 'product_replace_record',
    '/customer-special-price': 'contract_sales',
    '/sales/pharma-sales': 'pharma_sales',
    '/sales/doctor-overview': 'doctor_overview',
    '/sales/patient-overview': 'patient_overview',
    '/sales/view-sales-voucher': 'sales_voucher',
    '/sales/view-sales-return-voucher': 'sales_return_voucher',


    // CRM
  
    '/crm/customers': 'crm_customer_entry',
    '/crm/customers/addNewCustomer': 'crm_customer_entry',
    '/crm/leads': 'crm_leads',
    '/crm/deals': 'crm_deals',
    '/crm/tasks': 'crm_tasks',
    '/crm/customize': 'crm_customize',
    '/crm/customer-pending-list': 'pending_customer_list',
    '/crm/customer-approved-list': 'approved_customer_list',
    '/crm/customer-rejected-list': 'rejected_customer_list',
    '/crm/user-wise-customer-report': 'employee_wise_customer_list',


    // Accounts - Receivables
    '/accounts/debitor-receipts': 'debtor_receipt',
    '/accounts/debitor-receipts/add': 'debtor_receipt',
    '/accounts/debitor-receipts/edit/:id': 'debtor_receipt',
    '/reports/debitors-balance': 'debtor_balance',
    '/reports/debitors-report-due': 'debtor_balance_invoice_report',
    '/reports/debitor-balance-ledger': 'debtor_ledger',
    '/reports/collection-record': 'collection_record',
    '/reports/debtor-receipt-record': 'debtor_receipt_record',
    '/reports/advance-debtor-balance': 'advance_debtor_balance',

    // Accounts - Payables
    '/accounts/creditor-payments': 'creditor_payment',
    '/accounts/creditor-payments/add': 'creditor_payment',
    '/accounts/creditor-payments/edit/:id': 'creditor_payment',
    '/reports/creditors-balance': 'creditor_balance',
    '/reports/supplier-wise-outflow': 'supplier_wise_outflow',
    '/reports/outstanding-pdc': 'outstanding_pdc_report',
    '/reports/creditor-balance-ledger': 'creditor_ledger',
    '/reports/advance-creditor-balance': 'advance_creditor_balance',
    '/reports/creditor-payment-record': 'creditor_payment_record',

    // Accounts - Expenses
    '/accounts/expenses': 'expense_entry',
    '/accounts/expenses/add': 'expense_entry',
    '/accounts/expenses/edit/:id': 'expense_entry',
    '/accounts/expense-recognitions': 'expense_recognition_entry',
    '/accounts/expense-recognitions/add': 'expense_recognition_entry',
    '/accounts/expense-recognitions/edit/:id': 'expense_recognition_entry',
    '/reports/expense-record': 'expense_record',
    '/reports/expense-recognition-record': 'expense_recognition_record',
    '/reports/indirect-expenses-balance': 'indirect_expense_balance',
    '/reports/indirect-expense-ledger': 'indirect_expense_ledger',
    '/reports/direct-expense-balance': 'direct_expense_balance',
    '/reports/direct-expense-ledger': 'direct_expense_ledger',

    // Accounts - Income
    '/accounts/income': 'income_entry',
    '/accounts/income/add': 'income_entry',
    '/accounts/income/edit/:id': 'income_entry',
    '/reports/income-record': 'income_record',
    '/reports/indirect-income-balance': 'indirect_income_balance',
    '/reports/indirect-income-ledger': 'indirect_income_ledger',
    '/reports/direct-income-balance': 'direct_income_balance',
    '/reports/direct-income-ledger': 'direct_income_ledger',

    // Accounts - Journal & Contra
    '/accounts/journal-entry': 'journal_entry',
    '/accounts/journal-entry/add': 'journal_entry',
    '/accounts/journal-entry/edit/:id': 'journal_entry',
    '/reports/journal-record': 'journal_record',
    '/accounts/contra-entry': 'contra_entry',
    '/accounts/contra-entry/addNewContra': 'contra_entry',
    '/reports/contra-record': 'contra_record',

    // Accounts - Advance & Bank
    '/accounts/advance-tran': 'advance_transaction_entry',
    '/accounts/bank-transactions': 'bank_transactions',
    '/accounts/cheques': 'cheque_entry',

    // Accounts - Branch Transactions
    '/accounts/branch-tran': 'branch_tran',
    '/accounts/branch-tran/addNewBranchTransaction': 'branch_tran',
    '/reports/branch-tran-pending-list': 'branch_tran_pen_list',
    '/reports/branch-tran-receive-list': 'branch_tran_rcv_list',
    '/reports/branch-tran-transfer-list': 'branch_tran_transfer_list',
    '/reports/branch-tran-outward': 'branch_tran_transaction_outward',
    '/reports/branch-inward': 'branch_tran_transaction_inward',
    '/reports/branch-balance-report': 'branch_balance',
    '/reports/branch-ledger': 'branch_ledger',

    // Accounts - Chart of Accounts
    '/accounts/account-entry': 'account_entry',
    '/accounts/account-entry/addNewAccount': 'account_entry',
    '/accounts/opening-balances': 'account_entry',
    '/settings/location-manage': 'location_entry',
    '/settings/location-manage/addNewLocation': 'location_entry',
    '/reports/account-balance': 'cash_bank_balance',
    '/reports/account-ledger': 'cash_bank_ledger',
    '/reports/ageing-report': 'ageing_report',

    // Financial Reports
    '/reports/daily-ledger': 'daily_ledger',
    '/reports/profit-loss': 'profit_loss',
    '/reports/item-wise-profit': 'item_wise_profit_loss',
    '/reports/bill-wise-profit-loss': 'bill_wise_profit_loss',
    '/reports/balance-sheet': 'balance_sheet',
    '/reports/trial-balance': 'trial_balance',
    '/reports/loan-balance': 'loan_balance',
    '/reports/loan-ledger': 'loan_ledger',
    '/reports/emi-due-list': 'emi_due_list',

    // Asset Reports
    '/reports/fixed-asset-balance': 'fixed_asset_balance',
    '/reports/fixed-asset-ledger': 'fixed_asset_ledger',
    '/reports/intangible-asset': 'intangible_asset_balance',
    '/reports/current-assets-report': 'current_assets_balance',
    '/reports/current-asset-ledger': 'current_assets_ledger',
    '/reports/investment-balance': 'investment_balance',
    '/reports/investment-ledger': 'investment_ledger',

    // Liability & Capital
    '/reports/capitals-balance': 'capital_balance',
    '/reports/capital-ledger': 'capital_ledger',
    '/reports/current-liablity-report': 'current_liability',
    '/reports/current-liability-ledger': 'current_liability_ledger',
    '/reports/deposit-account-report': 'deposit_account_report',
    '/reports/deposit-account-ledger': 'deposit_account_ledger',
    '/reports/suspense-balance': 'suspense_balance',
    '/reports/suspense-ledger': 'suspense_ledger',
    '/reports/reserve-surplus-balance': 'reserve_surplus',
    '/reports/reserve-surplus-ledger': 'reserve_surplus_ledger',
    '/reports/account-transaction-report': 'account_transaction_report',

    // Tax & Service
    '/reports/tax-ledger': 'tax_ledger',
    '/reports/gstreturns': 'sales_return_gstr1',
    '/reports/purchase-gstreturns': 'purchase_return_gstr2',
    '/reports/gstr-3b-summary': 'gstr_3b_summary',

    '/service': 'service_entry',
    '/service/:id': 'service_voucher',
    '/service-record': 'service_record',
    '/service-return': 'service_return',
    '/service-expense': 'service_expense_entry',
    '/service-expense/:id': 'service_expense_voucher',
    '/reports/service-expense-record': 'service_expense_record',
    '/reports/service-ledger': 'service_ledger',
    '/reports/service-expense-ledger': 'service_expense_ledger',

    // Sales & Purchase Ledgers
    '/reports/sales-ledger': 'sales_ledger',
    '/reports/purchase-ledger': 'purchase_ledger',
    '/reports/sales-return-ledger': 'sales_return_ledger',
    '/reports/purchase-return-ledger': 'purchase_return_ledger',

    // Additional Reports
    '/reports/sales-record': 'sales_record_report',
    '/reports/sales-return-record': 'sales_return_record_report',
    '/reports/sales-replace-record': 'product_replace_record_report',
    '/reports/salary-report': 'salary_report',
    '/reports/monthly-salary-report': 'monthly_salary_report'

};

export const ROUTE_CONFIG = {
    "/reports/gstr-3b-summary": { access: "gstr_3b_summary", feature: "GST" },
    "/reports/gstreturns": { access: "sales_return_gstr1", feature: "GST" },
    "/reports/purchase-gstreturns": { access: "purchase-gstreturns", feature: "GST" },
    "/tatmeen": { access: "tatmeen_entry", feature: "TATMEEN_CUSTOM" }
};